<template>
  <div class="activityFile common_group">
    <div class="title">
      <img src="@/assets/images/fileIcon.png">
      <span>{{ $t('file.hdzlfj') }}</span>{{ $t('notic.hgtsinfo') }}
    </div>
    <div class="wrapper">
      <el-upload class="upload" :action="baseUrl" :before-upload="beforeUpload" :on-success="handleSuccess"
                 :on-progress="uploadVideoProcess" multiple :show-file-list="false"
      >
        <div>
          <el-button type="primary" :disabled="btnDisabled"><i class="iconfont icon-shangchuan-icon1" />{{ $t('file.ctu') }}</el-button>
          <span slot="tip">{{ $t('file.F50M') }}</span>
        </div>
      </el-upload>
      <ul class="fileList">
        <li v-for="(item, index) in fileList" :key="index">
          <i class="iconfont icon-a-fujian-iconkaobei" />
          <span>{{ item.name }}</span>
          <i class="iconfont icon--s-guanbi closeIconFont" v-show="!progressFlag" @click="beforeRemove(index)" />
          <el-progress v-if="index === fileList.length - 1 && progressFlag" :percentage="loadProgress" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';

export default {
  data () {
    return {
      loadProgress: 0,
      progressFlag: false,
      fileList: [],
      btnDisabled: false,
      //   baseUrl: window._env_.VUE_APP_FILESERVICE_URL // 'https://fileserviceoutside.ruijie.com.cn/api/file/marketActivity/15008559650934784/15008559650934784'
      baseUrl: 'https://fileserviceoutside.ruijie.com.cn/api/file/marketActivity/15008559650934784/15008559650934784'
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    editEchoData: {
      handler (newVal) {
        if (newVal && newVal.complianceProcessDetailVO && newVal.complianceProcessDetailVO.complianceAttachFileList.length > 0) {
          this.fileList = newVal.complianceProcessDetailVO.complianceAttachFileList.map(item => {
            item.name = item.fileName;
            return item;
          });
        } else {
          this.fileList = [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 上传文件前的钩子函数，用于进行文件验证和获取上传令牌
    beforeUpload (file) {
      this.btnDisabled = true;
      // 返回Promise以处理异步的文件上传前准备工作
      return new Promise((resolve, reject) => {
        // 检查文件大小是否小于100MB
        let fileSize = file.size / 1024 / 1024 < 50;

        // 如果文件大小超过50MB，显示错误信息并拒绝上传
        if (!fileSize) {
          this.$message.error(this.$t('file.uFn50M')); // 显示"文件大小不能超过50M"的错误提示
          reject(new Error(this.$t('file.uFn50M')));
          this.btnDisabled = false;
          return false;
        }

        // 调用API获取文件上传所需的token
        newApplicationFormApi.getFileToken().then(res => {
          // 检查API调用是否成功
          if (res.status === '200') {
            // 如果baseUrl中还没有包含Token参数，则添加Token参数
            if (this.baseUrl.indexOf('?Token=') < 0) {
              this.baseUrl = this.baseUrl + '?Token=' + res.data;
            }
            // 重置上传进度为0
            this.loadProgress = 0;
            // 将文件添加到文件列表中，只保存文件名信息
            this.fileList.push({
              name: file.name
            });
            // 解析Promise，表示可以开始上传
            resolve();
          } else {
            this.btnDisabled = false;
            // 如果获取token失败，拒绝上传并传递错误状态码
            reject(res.status);
          }
        }).catch(err => {
          this.btnDisabled = false;
          reject(err);
        });
      });
    },
    /**
 * 视频上传进度处理函数
 * @param {Object} event - 上传事件对象，包含进度信息
 * @param {Object} file - 当前上传的文件对象
 * @param {Array} fileList - 文件列表
 */
    uploadVideoProcess (event, file, fileList) {
      // 设置进度条显示标志为true，显示进度条
      this.progressFlag = true;
      // 当上传进度达到或超过100%时（表示上传完成但可能需要等待后端处理）
      if (event.percent >= 100) {
        // 创建定时器，模拟处理中的进度动画
        let interval = setInterval(() => {
          // 每次增加20%的加载进度
          this.loadProgress += 20;
          // 当进度接近100%时（达到99%）停止增加，保留1%等待最终确认
          if (this.loadProgress >= 99) {
            this.loadProgress = 99;
            // 清除定时器，停止进度增加
            clearInterval(interval);
          }
        }, 100); // 每100毫秒更新一次进度
      }
    },
    /**
 * 文件上传成功后的处理函数
 * @param {Object} response - 服务器返回的响应数据
 * @param {Object} file - 当前上传的文件对象
 * @param {Array} fileList - 文件列表
 */
    handleSuccess (response) {
      // 检查响应状态是否为200且包含文件ID
      if (response.status === '200' && response.data[0].FID) {
        // 设置加载进度为100%
        this.loadProgress = 100;
        // 在文件列表中查找当前上传的文件索引（通过文件名匹配）
        let fileIndex = this.fileList.findIndex(item => item.name === response.data[0].FullName);
        // 为找到的文件项添加fileId属性，值为服务器返回的FID
        this.fileList[fileIndex].fileId = response.data[0].FID;
        // 延迟800毫秒后隐藏进度条
        setTimeout(() => {
          this.progressFlag = false;
        }, 800);
      } else {
        // 上传失败时，从文件列表中移除最后添加的文件
        this.fileList.splice(this.fileList.length - 1, 1);
        // 隐藏进度条
        this.progressFlag = false;
        // 显示错误消息
        this.$message.error(response.err);
      }
       this.btnDisabled = false;
      // 重置baseUrl，移除URL中的Token参数部分
      this.baseUrl = this.baseUrl.split('?Token')[0];
    },
    beforeRemove (index) {
      this.fileList.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';

.activityFile {
  >.wrapper {
    background: #FCFDFE;
    border: 1px solid #DEE1E7;
    line-height: 30px;
    position: relative;
    @extend .clear;

    &:before {
      content: '';
      background: #FFFFFF;
      width: 100%;
      height: 1px;
      position: absolute;
      top: 0;
      left: 0;
    }

    >ul {
      >li {
        padding: 15px 0 15px 20px;
        border-top: 1px solid #E2E4E9;
        height: 20px;
        line-height: 20px;
        box-sizing: content-box;

        >i:first-child {
          font-size: 18px;
          margin-right: 15px;
          color: #B8B8B8;
        }

        >span {
          margin-right: 40px;
        }

        >.closeIconFont {
          display: none;
          vertical-align: middle;
          font-size: 16px;
          cursor: pointer;
          color: #dc5650;
        }

        &:hover>.closeIconFont {
          display: inline-block;
        }

        >.el-progress {
          width: 300px;
          display: inline-block;
        }
      }
    }

    ::v-deep>.upload {
      >.el-upload {
        padding: 20px;

        >div>span {
          margin-left: 10px;
          color: #5B646E;
        }
      }
    }
  }
}
</style>
